import localStorageKey from "../enumerations/localStorageKey";

import req from "./https.js";

let currentCurrency = null;

const toLogin = () => {
  window.location.href = "/signin";
};

export const request = (method, path, data = null, needAuth = false, needCurrency = true) => {
  const CURRENCY =
    window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${JSON.parse(process.env.REACT_APP_NEW_STRUCTURE) ? "" : CURRENCY}${process.env.REACT_APP_MAIN_API}${path}`, // hard-coding for IT test new domain
    data,
    needAuth,
    needCurrency,
  );
};

export const requestGlobalSettingData = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_GLOBAL_SETTING_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestGlobalUserData = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_GLOBAL_USER_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestMain = (method, path, data = null, needAuth = false, needCurrency = true) => {
  const CURRENCY =
    window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${JSON.parse(process.env.REACT_APP_NEW_STRUCTURE) ? "" : CURRENCY}${process.env.REACT_APP_MAIN_API}${path}`, // hard-coding for IT test new domain
    data,
    needAuth,
    needCurrency,
  );
};

export const requestWheel = (method, path, data = null, needAuth = false, needCurrency = true) => {
  const CURRENCY =
    window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${JSON.parse(process.env.REACT_APP_NEW_STRUCTURE) ? "" : CURRENCY}${process.env.REACT_APP_WHEEL_API}${path}`, // hard-coding for IT test new domain
    data,
    needAuth,
    needCurrency,
  );
};
export const requestWheelV2 = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) => {
  const CURRENCY =
    window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${JSON.parse(process.env.REACT_APP_NEW_STRUCTURE) ? "" : CURRENCY}${process.env.REACT_APP_WHEEL_V2_API}${path}`, // hard-coding for IT test new domain
    data,
    needAuth,
    needCurrency,
  );
};

export const requestSignIn = (method, path, data = null, needAuth = false, needCurrency = true) => {
  const CURRENCY =
    window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${JSON.parse(process.env.REACT_APP_NEW_STRUCTURE) ? "" : CURRENCY}${process.env.REACT_APP_SIGNIN_API}${path}`, // hard-coding for IT test new domain
    data,
    needAuth,
    needCurrency,
  );
};

export const requestGoldEgg = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) => {
  const CURRENCY =
    window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${JSON.parse(process.env.REACT_APP_NEW_STRUCTURE) ? "" : CURRENCY}${process.env.REACT_APP_GOLDEGG_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );
};

export const requestBet = (method, path, data = null, needAuth = false, needCurrency = true) => {
  const CURRENCY =
    window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${JSON.parse(process.env.REACT_APP_NEW_STRUCTURE) ? "" : CURRENCY}${process.env.REACT_APP_BET_API}${path}`, // hard-coding for IT test new domain
    data,
    needAuth,
    needCurrency,
  );
};

export const requestImage = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_IMAGE_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestWin = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WIN_URL}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestHistory = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_HISTORY_URL}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestCDN = async (method, path) =>
  await req(method, `${process.env.REACT_APP_CDN_URL}${path}`, {}, false, false, false, true);

export const requestBinance = (method, path, data = null) =>
  req(method, `${process.env.REACT_APP_BINANCE_URL}${path}`, data, false, false, false, true);

export const requestMg = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_MG_SLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestT1 = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_T1_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestEvo = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_EVO_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestPp = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_PP_SLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestPg = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_PG_SLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestYgg = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_YGG_SLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestEvoplay = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_EVOPLAY_SLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestJili = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_JILI_SLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestSpribe = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SPRIBE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestPT = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_PT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestPPLive = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_PPLIVE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestFC = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEPLAY_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );
export const requestCQ9 = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEPLAY_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );
export const requestPlayStar = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_PLAYSTAR_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestTcg = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_TCG_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestWeblockchain = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WEBLOCKCHAIN_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestWelive = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WELIVE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestWelottery = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WELOTTERY_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestYoubet = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_YOUBET_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestAesexy = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_AESEXY_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestSpribeone = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SPRIBEONE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

//WESPORT
export const requestWesport = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WESPORT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestLuckySport = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_LUCKYSPORT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestYbslot = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_YBSLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestWefish = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WEFISH_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestWeslot = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WESLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestFCFish = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_FCFISH_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestJDBFish = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_JDBFISH_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestJDBSlot = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_JDBSLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestViaCasinoLive = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_VIACASINOLIVE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestFFFLive = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_FFFLIVE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestWCF = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_WCF_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestJollySport = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_JOLLYSPORT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEJDBFISH = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEJDBFISH_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEJDBSLOT = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEJDBSLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEPP = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEPP_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEPG = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEPG_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEHACKSAW = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEHACKSAW_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEJILISLOT = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEJILISLOT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEJILIFISH = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEJILIFISH_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEJILICARD = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEJILICARD_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEJILICASINO = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEJILICASINO_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEEVOLIVE = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEEVOLIVE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEPPLIVE = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEPPLIVE_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONESABA = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONESABA_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestONEGLOBAL = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_ONEGLOBAL_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestAg = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_AG_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestOmg = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_OMG_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestMiniGame = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_MINIGAME_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const requestSBOSPORT = (
  method,
  path,
  data = null,
  needAuth = false,
  needCurrency = true,
) => {
  console.debug("mtdh", method);
  return req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SBOSPORT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );
};
export const requestCRSPORT = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_CRSPORT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );
export const requestFBSPORT = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_FBSPORT_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

export const request77 = (method, path, data = null, needAuth = false, needCurrency = true) =>
  req(
    method,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_DOUBLE_SEVEN_MAIN_API}${path}`,
    data,
    needAuth,
    needCurrency,
  );

const ALLOWED_PATH = ["/signin", "/signup", "/forgotPassword", "/", "/appDownload"];

const isAllowedWithoutCurrency = (path) => {
  return ALLOWED_PATH.includes(path);
};

if (window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) === null) {
  if (isAllowedWithoutCurrency && isAllowedWithoutCurrency(window.location.pathname) === false) {
    toLogin();
  }
} else {
  currentCurrency = window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
}
